import type { TFunction } from 'i18next'
import { z } from 'zod'

import { AutomaticPaymentRemindersType } from '../../../enums/automaticPaymentRemindersType'
import { getAutomaticPaymentRemindersDetailsSchema } from '../../../utils/getAutomaticPaymentRemindersDetailsSchema'
import { getAutomaticPaymentRemindersPostAfterDueDateSchema } from '../../../utils/getAutomaticPaymentRemindersPostAfterDueDateSchema'
import { getPaymentMethodsFormSchema } from '../../../utils/getPaymentMethodsFormSchema'
import type { PaymentsAndRemindersSettingsFormSchema } from '../types/paymentsAndRemindersSettingsFormSchema'

export const getPaymentsAndRemindersSettingsFormSchema = (t: TFunction): PaymentsAndRemindersSettingsFormSchema => {
  const paymentMethodsSchema = getPaymentMethodsFormSchema(t)

  const automaticPaymentRemindersSchema = z.object({
    automaticPaymentRemindersSettings: z.object({
      activationDate: z.date(),
      afterDueDate: getAutomaticPaymentRemindersDetailsSchema(t, AutomaticPaymentRemindersType.AfterDueDate),
      beforeDueDate: getAutomaticPaymentRemindersDetailsSchema(t, AutomaticPaymentRemindersType.BeforeDueDate),
      onDueDate: getAutomaticPaymentRemindersDetailsSchema(t, AutomaticPaymentRemindersType.OnDueDate),
      // Not editable here, but sent back with the rest of the reminder settings, like the old settings page does.
      postAfterDueDate: getAutomaticPaymentRemindersPostAfterDueDateSchema(t),
    }),
  })

  // The shared payment methods schema ends in superRefine, so it can't be extended; intersect it instead.
  return z.intersection(paymentMethodsSchema, automaticPaymentRemindersSchema)
}
